// // export default Index;
// import React, { useEffect, useState, useCallback } from "react";
// import logo from "../Assets/HerVeg.png";
// import { jwtDecode } from "jwt-decode";
// import supabase from "../Config/Supabase";
// import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
// import ProfilePictures from "../Components/ProfilePicture";
// // icons
// import { FaMoneyBillTrendUp, FaPowerOff } from "react-icons/fa6";
// import { FaRegUser } from "react-icons/fa6";
// import { IoPeople } from "react-icons/io5";
// import { FaHome } from "react-icons/fa";
// import { motion } from "framer-motion";
// import { HiMiniCheckBadge } from "react-icons/hi2";
// import { BsFillPeopleFill } from "react-icons/bs";
// import { GiStairsGoal } from "react-icons/gi";
// import { RiLuggageDepositFill } from "react-icons/ri";
// import { IoMdMenu } from "react-icons/io";
// import { MdWifiOff, MdWifi } from "react-icons/md";
// import { FaSackDollar } from "react-icons/fa6";
// import { IoMdSettings } from "react-icons/io";
// import { IoStatsChart } from "react-icons/io5";

// import db from "../local database/localDB";
// import Switcher from "../Darktheme/Switcher";
// import { Loader } from "lucide-react";

// // what account with administrator status can see
// const AdminRoutes = [
//   {
//     sections: "Home",
//     links: "home",
//     icon: <FaHome />,
//   },
//   {
//     sections: "Vano",
//     links: "vano",
//     icon: <BsFillPeopleFill />,
//   },
//   {
//     sections: "Offline Farmers",
//     links: "Offline_farmer",
//     icon: <IoPeople />,
//   },
//   {
//     sections: "Packages",
//     links: "packages",
//     icon: <RiLuggageDepositFill />,
//   },
//   {
//     sections: "Payments Updates",
//     links: "payments",
//     icon: <FaMoneyBillTrendUp />,
//   },
//   {
//     sections: "Objective",
//     links: "objective",
//     icon: <GiStairsGoal />,
//   },
// ];

// // what vano and other supervisors can see
// const OfficerRoutes = [
//   {
//     sections: "Home",
//     links: "home",
//     icon: <FaHome />,
//   },
//   {
//     sections: "Farmers",
//     links: "farmer",
//     icon: <IoPeople />,
//   },
//   {
//     sections: "Packages",
//     links: "packages",
//     icon: <RiLuggageDepositFill />,
//   },
//   {
//     sections: "Offline Farmers",
//     links: "Offline_farmer",
//     icon: <IoPeople />,
//   },
//   // {
//   //   sections: "Payments Updates",
//   //   links: "payments",
//   //   icon: <FaMoneyBillTrendUp />,
//   // },
// ];

// const Index = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [show, setshow] = useState(false);
//   const [user, setUser] = useState([]);
//   const [isOnline, setIsOnline] = useState(navigator.onLine);
//   const [isLoading, setIsLoading] = useState(true);
//   const [syncStatus, setSyncStatus] = useState("idle");

//   //page navigation
//   const navigate = useNavigate();

//   // Network status monitoring
//   useEffect(() => {
//     const handleOnline = () => {
//       setIsOnline(true);
//       // Attempt to sync when coming back online
//       syncOfflineData();
//     };

//     const handleOffline = () => {
//       setIsOnline(false);
//     };

//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);

//     return () => {
//       window.removeEventListener("online", handleOnline);
//       window.removeEventListener("offline", handleOffline);
//     };
//   }, []);

//   useEffect(() => {
//     fetchUser();
//   }, [isOnline]);

//   // Sync offline data when coming back online
//   const syncOfflineData = useCallback(async () => {
//     if (!isOnline) return;

//     setSyncStatus("syncing");
//     try {
//       // Fetch fresh data when online
//       await fetchUser();
//       setSyncStatus("synced");

//       // Reset sync status after showing success
//       setTimeout(() => setSyncStatus("idle"), 1000);
//     } catch (error) {
//       console.error("Sync failed:", error);
//       setSyncStatus("error");
//       setTimeout(() => setSyncStatus("idle"), 1000);
//     }
//   }, [isOnline]);

//   const fetchUser = async () => {
//     setIsLoading(true);
//     try {
//       if (isOnline) {
//         // Online: Fetch from Supabase
//         const { data, error } = await supabase.from("user").select();
//         if (error) {
//           throw new Error(error.message);
//         }

//         // Get token and decode
//         const token = localStorage.getItem("token");
//         if (!token) {
//           throw new Error("No authentication token found");
//         }

//         const users = jwtDecode(token);
//         const user = data?.find((dt) => dt?.email === users?.email);

//         if (user) {
//           setUser(user);
//           // Update local database with fresh data
//           await db.userProfile.clear();
//           await db.userProfile.add(user);
//         } else {
//           throw new Error("User not found in database");
//         }
//       } else {
//         // Offline: Load from local database
//         const offlineUserInfo = await db.userProfile.toArray();
//         if (offlineUserInfo.length > 0) {
//           setUser(offlineUserInfo[0]);
//         } else {
//           throw new Error("No offline user data available");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching user:", error);

//       // Fallback to offline data if online fetch fails
//       try {
//         const offlineUserInfo = await db.userProfile.toArray();
//         if (offlineUserInfo.length > 0) {
//           setUser(offlineUserInfo[0]);
//         } else {
//           // If no offline data, redirect to login
//           handleLogout();
//         }
//       } catch (offlineError) {
//         console.error("Error loading offline data:", offlineError);
//         handleLogout();
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const LogOutUser = async () => {
//     try {
//       if (isOnline) {
//         const { error } = await supabase.auth.signOut();
//         if (error) {
//           console.error(error.message);
//         }
//       }
//     } catch (error) {
//       console.error("Error signing out:", error);
//     }
//   };

//   // scrolll to top function
//   const scrollToTop = () => {
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });

//     // Check if the screen width is less than or equal to the tablet breakpoint (e.g., 768px)
//     if (window.innerWidth <= 768) {
//       toggleSidebar(); // Only toggle sidebar for tablet or mobile views
//     }
//   };

//   // Function to toggle the sidebar
//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//     setshow(false);
//   };

//   // button functons
//   const handleShow = () => {
//     setshow(!show);
//   };

//   // logOut function
//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     LogOutUser();
//     setUser(null);
//     // Clear offline data
//     db.userProfile.clear().catch(console.error);
//     navigate("/", { replace: true });
//   };

//   // Connection status indicator
//   const ConnectionStatus = () => (
//     <div
//       className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs ${
//         isOnline
//           ? "bg-green-100 dark:bg-green-600 dark:text-white text-green-700"
//           : "bg-red-100 dark:bg-red-600 dark:text-white text-red-700"
//       }`}
//     >
//       {isOnline ? (
//         <MdWifi className="w-3 h-3" />
//       ) : (
//         <MdWifiOff className="w-3 h-3" />
//       )}
//       <span className="hidden sm:inline">
//         {isOnline ? "Online" : "Offline"}
//       </span>
//       {syncStatus === "syncing" && <span className="ml-1 animate-spin">⟳</span>}
//       {syncStatus === "synced" && (
//         <span className="ml-1 text-green-600">✓</span>
//       )}
//       {syncStatus === "error" && <span className="ml-1 text-red-600">⚠</span>}
//     </div>
//   );

//   if (isLoading) {
//     return (
//       <div className="flex items-center justify-center min-h-screen dark:bg-gray-900 bg-gray-50">
//         <div className="flex flex-col items-center justify-center text-center">
//           <Loader className="animate-spin md:w-10 w-10 h-10 md:h-10 text-green-600 dark:text-gray-400 [animation-duration:0.5s]" />
//           <p className="mt-4 text-xs text-gray-600 md:text-sm animate-pulse">
//             Loading.
//           </p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex h-screen min-h-screen overflow-hidden bg-gray-100 dark:bg-gray-800">
//       {/* Sidebar */}
//       <aside
//         className={`fixed top-0 left-0 w-64 dark:bg-gray-900 bg-slate-100 h-full transform ${
//           isSidebarOpen ? "translate-x-0" : "-translate-x-full"
//         } md:translate-x-0 transition-transform duration-300 ease-in-out z-50 md:relative md:transform-none`}
//       >
//         <div
//           onClick={() => setshow(false)}
//           className="flex flex-col justify-between h-full p-6"
//         >
//           <div className="flex-1">
//             <div className="flex items-center justify-between mb-6">
//               <img src={logo} alt="herveg logo" className="h-10" />
//               <button
//                 className="p-1 rounded md:hidden hover:bg-gray-200"
//                 onClick={toggleSidebar}
//               >
//                 ✕
//               </button>
//             </div>

//             <nav className="flex-1">
//               {user?.role === "administrator" ? (
//                 <div className="flex flex-col w-full space-y-1">
//                   {AdminRoutes?.map((dt, index) => (
//                     <motion.div
//                       key={index}
//                       whileHover={{ scale: 1.02 }}
//                       whileTap={{ scale: 0.98 }}
//                       transition={{ type: "spring", ease: "easeOut" }}
//                       className="flex w-full"
//                     >
//                       <NavLink
//                         onClick={scrollToTop}
//                         className={({ isActive }) =>
//                           `flex flex-row items-center w-full px-4 py-3 rounded-lg transition-all duration-200 ${
//                             isActive
//                               ? "bg-green-600 text-white font-medium shadow-md"
//                               : "text-slate-700 dark:text-white hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-700 hover:font-medium"
//                           }`
//                         }
//                         to={dt.links}
//                       >
//                         <span className="mr-3 text-lg">{dt.icon}</span>
//                         <span className="text-sm xl:text-base line-clamp-1">
//                           {dt.sections}
//                         </span>
//                       </NavLink>
//                     </motion.div>
//                   ))}
//                 </div>
//               ) : (
//                 <div className="flex flex-col w-full space-y-1">
//                   {OfficerRoutes?.map((dt, index) => (
//                     <motion.div
//                       key={index}
//                       whileHover={{ scale: 1.02 }}
//                       whileTap={{ scale: 0.98 }}
//                       transition={{ type: "spring", ease: "easeOut" }}
//                       className="flex w-full"
//                     >
//                       <NavLink
//                         onClick={scrollToTop}
//                         className={({ isActive }) =>
//                           `flex flex-row items-center w-full px-4 py-3 rounded-lg transition-all duration-200 ${
//                             isActive
//                               ? "bg-green-600 text-white font-medium shadow-md"
//                               : "text-slate-700 dark:text-white hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-700 hover:font-medium"
//                           }`
//                         }
//                         to={dt.links}
//                       >
//                         <span className="mr-3 text-lg">{dt.icon}</span>
//                         <span className="text-sm xl:text-base line-clamp-1">
//                           {dt.sections}
//                         </span>
//                       </NavLink>
//                     </motion.div>
//                   ))}
//                   {user?.role === "supervisor" ||
//                   user?.role === "administrator" ? (
//                     <motion.div
//                       whileHover={{ scale: 1.02 }}
//                       whileTap={{ scale: 0.98 }}
//                       transition={{ type: "spring", ease: "easeOut" }}
//                       className="flex flex-col w-full"
//                     >
//                       <NavLink
//                         onClick={scrollToTop}
//                         className={({ isActive }) =>
//                           ` flex-row hidden items-center w-full px-4 py-3 rounded-lg transition-all duration-200 ${
//                             isActive
//                               ? "bg-green-600 text-white font-medium shadow-md"
//                               : "text-slate-700 dark:text-white hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-700 hover:font-medium"
//                           }`
//                         }
//                         to={"statistics"}
//                       >
//                         <span className="mr-3 text-lg">
//                           <IoStatsChart />
//                         </span>
//                         <span className="text-sm xl:text-base line-clamp-1">
//                           Statistics
//                         </span>
//                       </NavLink>
//                       <NavLink
//                         onClick={scrollToTop}
//                         className={({ isActive }) =>
//                           `flex flex-row items-center w-full px-4 py-3 rounded-lg transition-all duration-200 ${
//                             isActive
//                               ? "bg-green-600 text-white font-medium shadow-md"
//                               : "text-slate-700 dark:text-white hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-700 hover:font-medium"
//                           }`
//                         }
//                         to={"farmerSettings"}
//                       >
//                         <span className="mr-3 text-lg">
//                           <IoMdSettings />
//                         </span>
//                         <span className="text-sm xl:text-base line-clamp-1">
//                           Farmer Settings
//                         </span>
//                       </NavLink>
//                       <NavLink
//                         onClick={scrollToTop}
//                         className={({ isActive }) =>
//                           `flex flex-row items-center w-full px-4 py-3 rounded-lg transition-all duration-200 ${
//                             isActive
//                               ? "bg-green-600 text-white font-medium shadow-md"
//                               : "text-slate-700 dark:text-white hover:bg-green-50 dark:hover:bg-gray-700 hover:text-green-700 hover:font-medium"
//                           }`
//                         }
//                         to={"payments"}
//                       >
//                         <span className="mr-3 text-lg">
//                           <FaSackDollar />
//                         </span>
//                         <span className="text-sm xl:text-base line-clamp-1">
//                           Payments Updates
//                         </span>
//                       </NavLink>
//                     </motion.div>
//                   ) : (
//                     ""
//                   )}
//                 </div>
//               )}
//             </nav>
//           </div>

//           <div className="pt-4 border-t border-gray-200 ">
//             {/* Connection status */}
//             <div className="mb-4">
//               <ConnectionStatus />
//             </div>

//             {/* User profile details */}
//             <ProfilePictures data={user} />
//           </div>
//         </div>
//       </aside>

//       {/* Overlay for Sidebar on small screens */}
//       {isSidebarOpen && (
//         <div
//           className="fixed inset-0 z-40 bg-black/50 md:hidden"
//           onClick={toggleSidebar}
//         />
//       )}

//       {/* Main content */}
//       <div className="flex flex-col flex-1 overflow-hidden">
//         <header className="fixed top-0 z-30 flex items-center justify-between w-full px-2 py-1 shadow md:sticky md:px-4 dark:bg-gray-900 bg-slate-100 ">
//           {/* Button to toggle sidebar on mobile */}
//           <div className="flex items-center gap-3">
//             <button
//               className="p-2 text-gray-600 transition-colors rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
//               onClick={toggleSidebar}
//               aria-label="Toggle sidebar"
//             >
//               <IoMdMenu className="text-2xl" />
//             </button>

//             {/* Connection status on mobile */}
//             <div className="md:hidden">
//               <ConnectionStatus />
//             </div>
//           </div>

//           <div className="relative">
//             {/* profile */}
//             <div className="flex items-center p-2 transition-colors rounded-full cursor-pointer dark:hover:bg-gray-700 gap-x-2 hover:bg-gray-100">
//               <div className="ml-2">
//                 {/* dark theme toggle */}
//                 <Switcher />
//               </div>

//               <motion.img
//                 className="object-cover w-8 h-8 border-2 border-green-400 rounded-full shadow-sm md:h-10 md:w-10"
//                 src={`https://ui-avatars.com/api/?name=${user?.email}&background=EEF2FF&color=6366F1`}
//                 alt="User Avatar"
//                 initial={{ scale: 0 }}
//                 animate={{ scale: 1 }}
//                 transition={{ duration: 0.5 }}
//                 onClick={handleShow}
//               />
//               <svg
//                 className="w-4 h-4 text-gray-500"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//                 onClick={handleShow}
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth="2"
//                   d="M19 9l-7 7-7-7"
//                 />
//               </svg>
//             </div>

//             {show && (
//               <motion.div
//                 initial={{ opacity: 0, y: -10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -10 }}
//                 transition={{ duration: 0.2 }}
//                 className="absolute right-0 w-64 mt-2 overflow-hidden bg-white border border-gray-100 rounded-lg shadow-lg dark:border-gray-700 dark:bg-slate-700 top-12"
//               >
//                 <div className="p-4 border-b border-gray-100 dark:border-gray-400">
//                   <div className="flex items-center gap-x-3">
//                     <motion.img
//                       className="object-cover w-12 h-12 border-2 border-green-400 rounded-full"
//                       src={`https://ui-avatars.com/api/?name=${user?.email}&background=EEF2FF&color=6366F1`}
//                       alt="User Avatar"
//                     />
//                     <div className="flex-1 min-w-0">
//                       <h3 className="text-sm font-semibold text-gray-800 truncate dark:text-gray-300">
//                         {user?.name}
//                       </h3>
//                       <p className="text-xs text-gray-500 truncate dark:text-gray-400">
//                         {user?.email}
//                       </p>
//                       <div className="flex items-center mt-1">
//                         {user?.role === "supervisor" ||
//                         user?.role === "administrator" ? (
//                           <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
//                             <HiMiniCheckBadge className="mr-1" />
//                             Supervisor
//                           </span>
//                         ) : (
//                           <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                             <HiMiniCheckBadge className="mr-1" />
//                             Officer
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="py-2">
//                   <Link to={"userProfile"}>
//                     <div
//                       onClick={() => setshow(false)}
//                       className="flex items-center px-4 py-3 transition-colors hover:bg-gray-50"
//                     >
//                       <FaRegUser className="w-4 h-4 text-gray-500 dark:text-gray-300" />
//                       <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
//                         View Profile
//                       </span>
//                     </div>
//                   </Link>

//                   <button
//                     onClick={handleLogout}
//                     className="flex items-center w-full px-4 py-3 text-left transition-colors hover:bg-gray-50"
//                   >
//                     <FaPowerOff className="w-4 h-4 text-red-500" />
//                     <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-300">
//                       Log Out
//                     </span>
//                   </button>
//                 </div>
//               </motion.div>
//             )}
//           </div>
//         </header>

//         <main
//           onClick={() => setshow(false)}
//           className="flex-1 p-4 mt-16 overflow-y-auto md:mt-0 dark:bg-gray-800 bg-gray-50 md:p-6"
//         >
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// };

// export default Index;

// export default Index;
import React, { useEffect, useState, useCallback } from "react";
import logo from "../Assets/HerVeg.png";
import { jwtDecode } from "jwt-decode";
import supabase from "../Config/Supabase";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import ProfilePictures from "../Components/ProfilePicture";
// icons
import { FaMoneyBillTrendUp, FaPowerOff } from "react-icons/fa6";
import { FaRegUser } from "react-icons/fa6";
import { IoPeople } from "react-icons/io5";
import { FaHome } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { BsFillPeopleFill } from "react-icons/bs";
import { GiStairsGoal } from "react-icons/gi";
import { RiLuggageDepositFill } from "react-icons/ri";
import { IoMdMenu } from "react-icons/io";
import { MdWifiOff, MdWifi } from "react-icons/md";
import { FaSackDollar } from "react-icons/fa6";
import { IoMdSettings } from "react-icons/io";
//
import db from "../local database/localDB";
import Switcher from "../Darktheme/Switcher";
import { Loader } from "lucide-react";

// what account with administrator status can see
const AdminRoutes = [
  {
    sections: "Home",
    links: "home",
    icon: <FaHome />,
  },
  {
    sections: "Vano",
    links: "vano",
    icon: <BsFillPeopleFill />,
  },
  {
    sections: "Offline",
    links: "Offline_farmer",
    icon: <IoPeople />,
  },
  {
    sections: "Packages",
    links: "packages",
    icon: <RiLuggageDepositFill />,
  },
  {
    sections: "Payments Updates",
    links: "payments",
    icon: <FaMoneyBillTrendUp />,
  },
  {
    sections: "Objective",
    links: "objective",
    icon: <GiStairsGoal />,
  },
];

// what vano and other supervisors can see
const OfficerRoutes = [
  {
    sections: "Home",
    links: "home",
    icon: <FaHome />,
  },
  {
    sections: "Farmers",
    links: "farmer",
    icon: <IoPeople />,
  },
  {
    sections: "Packages",
    links: "packages",
    icon: <RiLuggageDepositFill />,
  },
  {
    sections: "Offline",
    links: "Offline_farmer",
    icon: <IoPeople />,
  },
  // {
  //   sections: "Payments Updates",
  //   links: "payments",
  //   icon: <FaMoneyBillTrendUp />,
  // },
];

const Index = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [show, setshow] = useState(false);
  const [user, setUser] = useState([]);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLoading, setIsLoading] = useState(true);
  const [syncStatus, setSyncStatus] = useState("idle");

  //page navigation
  const navigate = useNavigate();

  // Network status monitoring
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      // Attempt to sync when coming back online
      syncOfflineData();
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  useEffect(() => {
    fetchUser();
  }, [isOnline]);

  // Sync offline data when coming back online
  const syncOfflineData = useCallback(async () => {
    if (!isOnline) return;

    setSyncStatus("syncing");
    try {
      // Fetch fresh data when online
      await fetchUser();
      setSyncStatus("synced");

      // Reset sync status after showing success
      setTimeout(() => setSyncStatus("idle"), 1000);
    } catch (error) {
      console.error("Sync failed:", error);
      setSyncStatus("error");
      setTimeout(() => setSyncStatus("idle"), 1000);
    }
  }, [isOnline]);

  const fetchUser = async () => {
    setIsLoading(true);
    try {
      if (isOnline) {
        // Online: Fetch from Supabase
        const { data, error } = await supabase.from("user").select();
        if (error) {
          throw new Error(error.message);
        }

        // Get token and decode
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("No authentication token found");
        }

        const users = jwtDecode(token);
        const user = data?.find((dt) => dt?.email === users?.email);

        if (user) {
          setUser(user);
          // Update local database with fresh data
          await db.userProfile.clear();
          await db.userProfile.add(user);
        } else {
          throw new Error("User not found in database");
        }
      } else {
        // Offline: Load from local database
        const offlineUserInfo = await db.userProfile.toArray();
        if (offlineUserInfo.length > 0) {
          setUser(offlineUserInfo[0]);
        } else {
          throw new Error("No offline user data available");
        }
      }
    } catch (error) {
      console.error("Error fetching user:", error);

      // Fallback to offline data if online fetch fails
      try {
        const offlineUserInfo = await db.userProfile.toArray();
        if (offlineUserInfo.length > 0) {
          setUser(offlineUserInfo[0]);
        } else {
          // If no offline data, redirect to login
          handleLogout();
        }
      } catch (offlineError) {
        console.error("Error loading offline data:", offlineError);
        handleLogout();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const LogOutUser = async () => {
    try {
      if (isOnline) {
        const { error } = await supabase.auth.signOut();
        if (error) {
          console.error(error.message);
        }
      }
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  // scrolll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    // Check if the screen width is less than or equal to the tablet breakpoint (e.g., 768px)
    if (window.innerWidth <= 768) {
      toggleSidebar(); // Only toggle sidebar for tablet or mobile views
    }
  };

  // Function to toggle the sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setshow(false);
  };

  // button functons
  const handleShow = () => {
    setshow(!show);
  };

  // logOut function
  const handleLogout = () => {
    localStorage.removeItem("token");
    LogOutUser();
    setUser(null);
    // Clear offline data
    db.userProfile.clear().catch(console.error);
    navigate("/", { replace: true });
  };

  // Connection status indicator
  const ConnectionStatus = () => (
    <div
      className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border transition-colors ${
        isOnline
          ? "bg-emerald-50 border-emerald-200 text-emerald-700 dark:bg-emerald-500/10 dark:border-emerald-500/30 dark:text-emerald-400"
          : "bg-rose-50 border-rose-200 text-rose-700 dark:bg-rose-500/10 dark:border-rose-500/30 dark:text-rose-400"
      }`}
    >
      <span className="relative flex w-2 h-2">
        {isOnline && (
          <span className="absolute inline-flex w-full h-full rounded-full opacity-75 bg-emerald-400 animate-ping" />
        )}
        <span
          className={`relative inline-flex w-2 h-2 rounded-full ${
            isOnline ? "bg-emerald-500" : "bg-rose-500"
          }`}
        />
      </span>
      {isOnline ? (
        <MdWifi className="w-3.5 h-3.5" />
      ) : (
        <MdWifiOff className="w-3.5 h-3.5" />
      )}
      <span className="inline">{isOnline ? "Online" : "Offline"}</span>
      {syncStatus === "syncing" && (
        <span className="ml-0.5 animate-spin">⟳</span>
      )}
      {syncStatus === "synced" && (
        <span className="ml-0.5 text-emerald-600">✓</span>
      )}
      {syncStatus === "error" && (
        <span className="ml-0.5 text-rose-600">⚠</span>
      )}
    </div>
  );

  // Nav item renderer shared by sidebar (kept as its own block below so
  // desktop sidebar markup / behaviour is unchanged)
  const renderNavLink = (dt, index) => (
    <motion.div
      key={index}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={{ type: "spring", ease: "easeOut" }}
      className="flex w-full"
    >
      <NavLink
        onClick={scrollToTop}
        className={({ isActive }) =>
          `group flex flex-row items-center w-full px-4 py-3 rounded-xl transition-all duration-200 ${
            isActive
              ? "bg-green-600 text-white font-medium shadow-lg shadow-emerald-600/20"
              : "text-slate-600 dark:text-slate-300 hover:bg-emerald-50 dark:hover:bg-white/5 hover:text-emerald-700 dark:hover:text-emerald-400"
          }`
        }
        to={dt.links}
      >
        <span className="mr-3 text-lg">{dt.icon}</span>
        <span className="text-sm xl:text-base line-clamp-1">{dt.sections}</span>
      </NavLink>
    </motion.div>
  );

  // Primary shortcuts shown in the mobile bottom bar (first 4 of whichever
  // route set applies). Anything beyond that stays reachable through the
  // "More" button, which opens the existing sidebar drawer.
  const activeRoutes =
    user?.role === "administrator" ? AdminRoutes : OfficerRoutes;
  const mobilePrimaryRoutes = activeRoutes.slice(0, 4);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <div className="flex flex-col items-center justify-center text-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-emerald-500/20 blur-xl" />
            <Loader className="relative w-10 h-10 text-emerald-600 md:w-12 md:h-12 dark:text-emerald-400 animate-spin [animation-duration:0.6s]" />
          </div>
          <p className="mt-4 text-xs font-medium tracking-wide text-gray-500 md:text-sm dark:text-gray-400 animate-pulse">
            Loading…
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen min-h-screen overflow-hidden bg-gray-100 dark:bg-gray-900">
      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 w-72 max-w-[80vw] bg-white/95 dark:bg-gray-900 backdrop-blur-xl border-r border-gray-100 dark:border-white/5 h-full transform ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0 transition-transform duration-300 ease-in-out z-50 md:relative md:transform-none md:w-64`}
      >
        <div
          onClick={() => setshow(false)}
          className="flex flex-col justify-between h-full p-5"
        >
          <div className="flex-1 min-h-0 overflow-y-auto">
            <div className="flex items-center justify-between px-1 mb-8">
              <img src={logo} alt="herveg logo" className="h-12 md:h-14" />
              <button
                className="p-1.5 text-gray-400 rounded-lg md:hidden hover:bg-gray-100 dark:hover:bg-white/10 dark:text-gray-300"
                onClick={toggleSidebar}
              >
                ✕
              </button>
            </div>

            <nav className="flex-1">
              {user?.role === "administrator" ? (
                <div className="flex flex-col w-full space-y-1">
                  {AdminRoutes?.map((dt, index) => renderNavLink(dt, index))}
                </div>
              ) : (
                <div className="flex flex-col w-full space-y-1">
                  {OfficerRoutes?.map((dt, index) => renderNavLink(dt, index))}
                  {user?.role === "supervisor" ||
                  user?.role === "administrator" ? (
                    <motion.div
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      transition={{ type: "spring", ease: "easeOut" }}
                      className="flex flex-col w-full mt-2 space-y-1 border-gray-100 dark:border-white/5"
                    >
                      <NavLink
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          `flex flex-row items-center w-full px-4 py-3 rounded-xl transition-all duration-200 ${
                            isActive
                              ? "bg-green-600 text-white font-medium shadow-lg shadow-emerald-600/20"
                              : "text-slate-600 dark:text-slate-300 hover:bg-emerald-50 dark:hover:bg-white/5 hover:text-emerald-700 dark:hover:text-emerald-400"
                          }`
                        }
                        to={"farmerSettings"}
                      >
                        <span className="mr-3 text-lg">
                          <IoMdSettings />
                        </span>
                        <span className="text-sm xl:text-base line-clamp-1">
                          Farmer Settings
                        </span>
                      </NavLink>
                      <NavLink
                        onClick={scrollToTop}
                        className={({ isActive }) =>
                          `flex flex-row items-center w-full px-4 py-3 rounded-xl transition-all duration-200 ${
                            isActive
                              ? "bg-green-600 text-white font-medium shadow-lg shadow-emerald-600/20"
                              : "text-slate-600 dark:text-slate-300 hover:bg-emerald-50 dark:hover:bg-white/5 hover:text-emerald-700 dark:hover:text-emerald-400"
                          }`
                        }
                        to={"payments"}
                      >
                        <span className="mr-3 text-lg">
                          <FaSackDollar />
                        </span>
                        <span className="text-sm xl:text-base line-clamp-1">
                          Payments Updates
                        </span>
                      </NavLink>
                    </motion.div>
                  ) : (
                    ""
                  )}
                </div>
              )}
            </nav>
          </div>

          <div className="pt-4 mt-4 border-t border-gray-100 dark:border-white/40">
            {/* Connection status */}
            <div className="mb-4 md:hidden">
              <ConnectionStatus />
            </div>

            {/* User profile details */}
            <ProfilePictures data={user} />
          </div>
        </div>
      </aside>

      {/* Overlay for Sidebar on small screens */}
      <AnimatePresence>
        {isSidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden"
            onClick={toggleSidebar}
          />
        )}
      </AnimatePresence>

      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <header className="fixed top-0 z-30 flex items-center justify-between w-full px-3 py-2 border-b border-gray-100 md:px-6 dark:border-white/5 md:sticky bg-white/80 dark:bg-gray-900/80 backdrop-blur-xl">
          {/* Button to toggle sidebar on mobile */}
          <div className="flex items-center gap-3">
            <button
              className="hidden p-2 text-gray-500 transition-colors rounded-lg md:hidden hover:bg-gray-100 dark:hover:bg-white/10 dark:text-gray-300 focus:outline-none focus:ring-2 focus:ring-emerald-200"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
            >
              <IoMdMenu className="text-2xl" />
            </button>

            {/* Connection status on mobile */}
            <div className="md:hidden">
              <ConnectionStatus />
            </div>

            {/* Connection status on desktop, next to page context */}
            <div className="hidden md:block">
              <ConnectionStatus />
            </div>
          </div>

          <div className="relative">
            {/* profile */}
            <div
              className="flex items-center p-1.5 md:p-2 transition-colors rounded-full cursor-pointer dark:hover:bg-white/10 gap-x-2 hover:bg-gray-100"
              onClick={handleShow}
            >
              <div
                className="ml-1 md:ml-2"
                onClick={(e) => e.stopPropagation()}
              >
                {/* dark theme toggle */}
                <Switcher />
              </div>

              <motion.img
                className="object-cover w-8 h-8 border-2 rounded-full shadow-sm border-emerald-400 md:h-10 md:w-10"
                src={`https://ui-avatars.com/api/?name=${user?.email}&background=EEF2FF&color=6366F1`}
                alt="User Avatar"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.5 }}
              />
              <svg
                className={`hidden w-4 h-4 text-gray-400 transition-transform sm:block ${
                  show ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>

            <AnimatePresence>
              {show && (
                <motion.div
                  initial={{ opacity: 0, y: -10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.2 }}
                  className="absolute right-0 w-64 mt-2 overflow-hidden bg-white border border-gray-100 shadow-xl rounded-2xl dark:border-white/10 dark:bg-gray-800 top-12"
                >
                  <div className="p-4 border-b border-gray-100 dark:border-white/10">
                    <div className="flex items-center gap-x-3">
                      <motion.img
                        className="object-cover w-12 h-12 border-2 rounded-full border-emerald-400"
                        src={`https://ui-avatars.com/api/?name=${user?.email}&background=EEF2FF&color=6366F1`}
                        alt="User Avatar"
                      />
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-semibold text-gray-800 truncate dark:text-gray-100">
                          {user?.name}
                        </h3>
                        <p className="text-xs text-gray-500 truncate dark:text-gray-400">
                          {user?.email}
                        </p>
                        <div className="flex items-center mt-1.5">
                          {user?.role === "supervisor" ||
                          user?.role === "administrator" ? (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-500/10 dark:text-blue-400">
                              <HiMiniCheckBadge className="mr-1" />
                              Supervisor
                            </span>
                          ) : (
                            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-400">
                              <HiMiniCheckBadge className="mr-1" />
                              Officer
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="py-2">
                    <Link to={"userProfile"}>
                      <div
                        onClick={() => setshow(false)}
                        className="flex items-center px-4 py-3 transition-colors hover:bg-gray-50 dark:hover:bg-white/5"
                      >
                        <FaRegUser className="w-4 h-4 text-gray-500 dark:text-gray-300" />
                        <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-200">
                          View Profile
                        </span>
                      </div>
                    </Link>

                    <button
                      onClick={handleLogout}
                      className="flex items-center w-full px-4 py-3 text-left transition-colors hover:bg-rose-50 dark:hover:bg-rose-500/10"
                    >
                      <FaPowerOff className="w-4 h-4 text-rose-500" />
                      <span className="ml-3 text-sm font-medium text-gray-700 dark:text-gray-200">
                        Log Out
                      </span>
                    </button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </header>

        <main
          onClick={() => setshow(false)}
          className="flex-1 px-4 py-1 pb-20 mt-16 overflow-y-auto bg-gray-100 md:pb-5 md:mt-0 dark:bg-gray-800 md:px-6"
        >
          <Outlet />
        </main>

        {/* Mobile bottom navigation */}
        <nav
          className="fixed bottom-0 left-0 z-40 flex items-center justify-around w-full px-1 pt-1.5 border-t border-gray-100 md:hidden bg-white/95 dark:bg-gray-900 backdrop-blur-xl dark:border-white/5"
          style={{ paddingBottom: "max(env(safe-area-inset-bottom), 0.5rem)" }}
        >
          {mobilePrimaryRoutes?.map((dt, index) => (
            <NavLink
              key={index}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setshow(false);
              }}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center flex-1 min-w-0 py-1.5 rounded-lg transition-colors ${
                  isActive
                    ? "text-green-600 dark:text-green-400"
                    : "text-gray-400 dark:text-gray-500"
                }`
              }
              to={dt.links}
            >
              <span className="text-xl">{dt.icon}</span>
              <span className="mt-0.5 text-[10px] font-medium line-clamp-1 max-w-[64px]">
                {dt.sections}
              </span>
            </NavLink>
          ))}

          {user?.role === "supervisor" || user?.role === "administrator" ? (
            <>
              <button
                onClick={toggleSidebar}
                className={`flex flex-col items-center justify-center flex-1 min-w-0 py-1.5 rounded-lg transition-colors ${
                  isSidebarOpen
                    ? "text-emerald-600 dark:text-emerald-400"
                    : "text-gray-400 dark:text-gray-500"
                }`}
              >
                <IoMdMenu className="text-xl" />
                <span className="mt-0.5 text-[10px] font-medium">More</span>
              </button>
            </>
          ) : (
            ""
          )}
        </nav>
      </div>
    </div>
  );
};

export default Index;
